import { useEffect, useState } from "preact/hooks";
import { CloseIcon } from "./CloseIcon";
import classNames from "classnames";

interface ToastProps {
  message: string;
  dissapearAfter?: number;
  show: boolean;
  onClose?: () => void;
}

export default function Toast(props: ToastProps) {
  const { message } = props;
  const [show, setShow] = useState<boolean>(props.show);
  const [fadingOut, setFadingOut] = useState<boolean>(false);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  function fadeOut() {
    if (timer !== null) {
      clearTimeout(timer);
    }
    props.onClose?.();
    setFadingOut(true);
    setTimeout(() => {
      setShow(false);
      setFadingOut(false);
    }, 300);
  }

  function maybeScheduleClose() {
    if (props.dissapearAfter !== undefined) {
      const timer = setTimeout(() => {
        fadeOut();
      }, props.dissapearAfter);

      setTimer(timer);
      return timer;
    }
    return null;
  }

  useEffect(() => {
    if (props.show === false) {
      fadeOut();
    }
    if (props.show === true) {
      maybeScheduleClose();
    }
  }, [props.dissapearAfter, props.show]);

  if (show === false) {
    return null;
  }

  return (
    <div
      onMouseEnter={() => {
        if (timer !== null) {
          clearTimeout(timer);
        }
      }}
      onMouseLeave={() => {
        maybeScheduleClose();
      }}
      className={classNames(
        "fixed duration-300 bottom-[20px] left-1/2 bg-gray-900 rounded-lg text-white px-4 py-3 shadow-lg flex items-center translate-x-[-50%] max-w-[80vw] transition-opacity",
        {
          "opacity-0": fadingOut,
          "opacity-100": !fadingOut,
        }
      )}
    >
      <div className="pr-2 w-[300px]">{message}</div>
      <button
        className="hover:text-white text-gray-400"
        onClick={() => {
          fadeOut();
        }}
      >
        <CloseIcon />
      </button>
    </div>
  );
}
